// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"115":"3ee78727","354":"1d15bce2","843":"73f3a885"}[chunkId] + ".css";
};